import { Component } from 'react';
import { fromJS, get } from 'immutable';
import { FormattedMessage, injectIntl } from 'react-intl';
import { isNull } from 'lodash';
import mixpanel from 'mixpanel-browser';

import { FLASH_MESSAGE_TYPES, MANAGED_VIEWS } from 'constants/common';

import DropdownMenu, { CLASSES } from 'components/DropdownMenu';
import FlashMessage from 'components/FlashMessage';
import SaveViewModal from 'components/Modals/SaveView';
import DeleteConfirmation from 'components/Modals/DeleteConfirmation';
import EditColumns from 'components/Modals/EditColumns';

import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { createStructuredSelector } from 'reselect';

import { selectLoading } from 'services/Views/selectors';

import { renameView, setDefaultView, deleteView } from 'services/Views/thunks';

import { Title, ChooseView, Footer } from './styles';
import { ifInTestingMode } from 'utils/tests.utils';
import { ANALYTICS_EVENTS } from 'constants/mixpanel.constants';

export class Views extends Component {
  static defaultProps = {
    views: fromJS([]),
  };

  state = {
    flashMessageVisible: false,
    flashMessageType: null,
    flashMessage: null,
    saveModalVisible: false,
    deleteModalVisible: false,
    editColumnsVisible: false,
    stashedProps: {
      loading: false,
    },
  };

  static getDerivedStateFromProps(nextProps, nextState) {
    const newState = {
      stashedProps: {
        loading: nextProps.loading,
      },
    };

    if (nextState.stashedProps.loading && !nextProps.loading) {
      return {
        ...newState,
        saveModalVisible: false,
        deleteModalVisible: false,
      };
    }

    return newState;
  }

  // @ts-expect-error TS(2339): Property 'onSelectView' does not exist on type 'Re... Remove this comment to see the full error message
  getDropDownClickHandler = (view) => () => this.props.onSelectView(view);

  getTranslatedViewName = (name) =>
    MANAGED_VIEWS.includes(name) ? { translationId: `components.Views.managed.${name}` } : name;

  // List of views
  // In the long run, the `all` view will be in the database
  getDropdownViews = () =>
    // @ts-expect-error TS(2339): Property 'views' does not exist on type 'Readonly<... Remove this comment to see the full error message
    this.props.views
      .insert(
        0,
        fromJS({
          id: null,
          // @ts-expect-error TS(2339): Property 'intl' does not exist on type 'Readonly<{... Remove this comment to see the full error message
          name: this.props.intl.formatMessage({ id: 'components.Views.all' }),
          rules: [],
        })
      )
      .map((item, index) =>
        fromJS({
          id: `${item.get('name')}_${index}`,
          renderedValue: this.getTranslatedViewName(item.get('name', '')),
          handleClick: this.getDropDownClickHandler(!isNull(item.get('id')) ? item : null),
        })
      );

  // This returns the different options to manage views
  getViewDropdownOptions = () => {
    const options = [
      {
        id: 'editColumns',
        renderedValue: { translationId: 'components.Views.editColumns' },
        handleClick: this.handleToggleEditColumnsModal,
      },
    ];

    // @ts-expect-error TS(2339): Property 'activeView' does not exist on type 'Read... Remove this comment to see the full error message
    if (this.props.activeView) {
      options.push({
        id: 'renameView',
        renderedValue: { translationId: 'components.Views.renameView' },
        handleClick: this.handleToggleRenameView,
      });

      options.push({
        id: 'deleteView',
        renderedValue: { translationId: 'components.Views.deleteView' },
        handleClick: this.handleToggleDeleteModal,
      });
    }

    // @ts-expect-error TS(2339): Property 'views' does not exist on type 'Readonly<... Remove this comment to see the full error message
    const existingDefault = this.props.views.find((view) => view.get('isDefault'));

    options.push({
      id: 'makeDefault',
      renderedValue: { translationId: 'components.Views.makeDefault' },
      handleClick: this.handleMakeDefault,
      // @ts-expect-error TS(2345): Argument of type '{ id: string; renderedValue: { t... Remove this comment to see the full error message
      disabled:
        // @ts-expect-error TS(2339): Property 'activeView' does not exist on type 'Read... Remove this comment to see the full error message
        (this.props.activeView && this.props.activeView.get('isDefault')) ||
        // @ts-expect-error TS(2339): Property 'activeView' does not exist on type 'Read... Remove this comment to see the full error message
        (!this.props.activeView && typeof existingDefault === 'undefined'),
    });

    return fromJS(options);
  };

  // Opens the flash message
  handleOpenFlashMessage = (text, type) => {
    this.setState({
      flashMessageVisible: true,
      flashMessageType: type,
      flashMessage: text,
    });
  };

  // Closes the flash message
  handleCloseFlashMessage = () => {
    this.setState({
      flashMessageVisible: false,
      flashMessageType: null,
      flashMessage: null,
    });
  };

  // Toggles the edit columns modal
  handleToggleEditColumnsModal = () => {
    if (this.state.editColumnsVisible) {
      // @ts-expect-error TS(2339): Property 'onCancelColumnsChanges' does not exist o... Remove this comment to see the full error message
      this.props.onCancelColumnsChanges();
    }

    this.setState({ editColumnsVisible: !this.state.editColumnsVisible });
  };

  // Saves the new columns selection and ordering to the store
  handleApplyColumnsModifications = (columns) => {
    // @ts-expect-error TS(2339): Property 'onApplyColumnsChanges' does not exist on... Remove this comment to see the full error message
    this.props.onApplyColumnsChanges(columns);

    this.setState({ editColumnsVisible: false });
  };

  // Toggles the modal to rename the view
  handleToggleRenameView = () => {
    this.setState({
      saveModalVisible: !this.state.saveModalVisible,
    });
  };

  // Renames the view
  handleRenameView = (viewName) => {
    // @ts-expect-error TS(2339): Property 'activeView' does not exist on type 'Read... Remove this comment to see the full error message
    const { activeView } = this.props;

    // TODO: Move async actions out of component
    // @ts-expect-error TS(2339): Property 'renameView' does not exist on type 'Read... Remove this comment to see the full error message
    this.props.renameView(get(activeView, 'id'), viewName).then(() => {
      // @ts-expect-error TS(2339): Property 'intl' does not exist on type 'Readonly<{... Remove this comment to see the full error message
      const message = this.props.intl.formatMessage({
        id: 'notification.viewRenamed',
      });

      this.handleOpenFlashMessage(`${message} ${viewName}`, FLASH_MESSAGE_TYPES.success);
    });
  };

  // Toggles the delete modal
  handleToggleDeleteModal = () => {
    this.setState({
      deleteModalVisible: !this.state.deleteModalVisible,
    });
  };

  // Deletes the view
  handleDeleteView = () => {
    // @ts-expect-error TS(2339): Property 'activeView' does not exist on type 'Read... Remove this comment to see the full error message
    const { activeView } = this.props;

    if (!activeView) {
      return;
    }

    const viewName = activeView.get('name');

    // @ts-expect-error TS(2339): Property 'deleteView' does not exist on type 'Read... Remove this comment to see the full error message
    this.props.deleteView(activeView.get('id')).then(() => {
      this.handleOpenFlashMessage(
        // @ts-expect-error TS(2339): Property 'intl' does not exist on type 'Readonly<{... Remove this comment to see the full error message
        `${viewName} ${this.props.intl.formatMessage({
          id: 'notification.viewDeleted',
        })}`,
        FLASH_MESSAGE_TYPES.success
      );
    });
  };

  // Makes the view default
  handleMakeDefault = () => {
    // @ts-expect-error TS(2339): Property 'activeView' does not exist on type 'Read... Remove this comment to see the full error message
    const { activeView } = this.props;

    if (!activeView) {
      // In the case of "All" being selected, we just want to
      // set the existing default view to false
      // @ts-expect-error TS(2339): Property 'views' does not exist on type 'Readonly<... Remove this comment to see the full error message
      const existingDefaultView = this.props.views.find((view) => view.get('isDefault'));

      if (existingDefaultView) {
        // TODO: Move async actions out of component
        // @ts-expect-error TS(2339): Property 'setDefaultView' does not exist on type '... Remove this comment to see the full error message
        this.props.setDefaultView(existingDefaultView.get('id'), false).then(() => {
          this.handleOpenFlashMessage(
            // @ts-expect-error TS(2339): Property 'intl' does not exist on type 'Readonly<{... Remove this comment to see the full error message
            `${this.props.intl.formatMessage({
              id: 'components.Views.all',
              // @ts-expect-error TS(2339): Property 'intl' does not exist on type 'Readonly<{... Remove this comment to see the full error message
            })} ${this.props.intl.formatMessage({
              id: 'notification.viewIsNowDefault',
            })}`,
            FLASH_MESSAGE_TYPES.success
          );
        });
      }
    } else {
      // TODO: Move async actions out of component
      // @ts-expect-error TS(2339): Property 'setDefaultView' does not exist on type '... Remove this comment to see the full error message
      this.props.setDefaultView(activeView.get('id')).then(() => {
        this.handleOpenFlashMessage(
          // @ts-expect-error TS(2339): Property 'intl' does not exist on type 'Readonly<{... Remove this comment to see the full error message
          `${activeView.get('name')} ${this.props.intl.formatMessage({
            id: 'notification.viewIsNowDefault',
          })}`,
          FLASH_MESSAGE_TYPES.success
        );
      });
    }
  };

  render() {
    let deleteConfirmationMessage = '';

    // @ts-expect-error TS(2339): Property 'activeView' does not exist on type 'Read... Remove this comment to see the full error message
    if (this.props.activeView) {
      // @ts-expect-error TS(2339): Property 'intl' does not exist on type 'Readonly<{... Remove this comment to see the full error message
      deleteConfirmationMessage = this.props.intl.formatMessage(
        { id: 'components.Views.deleteConfirmationMessage' },
        // @ts-expect-error TS(2339): Property 'activeView' does not exist on type 'Read... Remove this comment to see the full error message
        { name: this.props.activeView.get('name') }
      );
    }
    return (
      <div>
        {/*
          TODO: Flash Messages should be handled at the TOP of
          the application, this should be passed a
          FlashMessageEmmiter or something equivalent do
          FlashMessages can be appropriately delegated
        */}
        <FlashMessage
          visible={this.state.flashMessageVisible}
          type={this.state.flashMessageType}
          text={this.state.flashMessage}
          onClose={this.handleCloseFlashMessage}
        />

        {this.state.saveModalVisible && (
          <SaveViewModal
            // @ts-expect-error TS(2322): Type '{ loading: any; initialViewName: any; onClos... Remove this comment to see the full error message
            loading={this.props.loading}
            // @ts-expect-error TS(2339): Property 'activeView' does not exist on type 'Read... Remove this comment to see the full error message
            initialViewName={this.props.activeView ? this.props.activeView.get('name') : ''}
            onCloseModal={this.handleToggleRenameView}
            onSave={this.handleRenameView}
          />
        )}

        {this.state.deleteModalVisible && (
          <DeleteConfirmation
            // @ts-expect-error TS(2769): No overload matches this call.
            loading={this.props.loading}
            // @ts-expect-error TS(2339): Property 'intl' does not exist on type 'Readonly<{... Remove this comment to see the full error message
            title={this.props.intl.formatMessage({
              id: 'components.Views.deleteConfirmationTitle',
            })}
            message={deleteConfirmationMessage}
            onCloseModal={this.handleToggleDeleteModal}
            onDelete={this.handleDeleteView}
          />
        )}

        {this.state.editColumnsVisible && (
          <EditColumns
            // @ts-expect-error TS(2322): Type '{ fields: any; columnConfig: any; loading: a... Remove this comment to see the full error message
            fields={this.props.fields}
            // @ts-expect-error TS(2339): Property 'columnConfig' does not exist on type 'Re... Remove this comment to see the full error message
            columnConfig={this.props.columnConfig}
            // @ts-expect-error TS(2339): Property 'loading' does not exist on type 'Readonl... Remove this comment to see the full error message
            loading={this.props.loading}
            // @ts-expect-error TS(2339): Property 'onToggleColumnVisibility' does not exist... Remove this comment to see the full error message
            onToggleColumnVisibility={this.props.onToggleColumnVisibility}
            onCloseModal={this.handleToggleEditColumnsModal}
            onSave={this.handleApplyColumnsModifications}
          />
        )}

        <Title>
          <FormattedMessage id="components.Views.title" />
        </Title>

        <ChooseView
          data-testid={ifInTestingMode('filtered-table__select-view-dropdown')}
          onClick={() => mixpanel.track(ANALYTICS_EVENTS.VIEWS_DROPDOWN)}
        >
          <DropdownMenu
            renderedValue={
              // @ts-expect-error TS(2339): Property 'activeView' does not exist on type 'Read... Remove this comment to see the full error message
              this.props.activeView
                ? // @ts-expect-error TS(2339): Property 'activeView' does not exist on type 'Read... Remove this comment to see the full error message
                  this.getTranslatedViewName(this.props.activeView.get('name'))
                : { translationId: 'components.Views.all' }
            }
            items={this.getDropdownViews()}
            className={`${CLASSES.FULL_WIDTH}`}
            button
            subtle
          />
        </ChooseView>

        <Footer>
          <div>
            {/* @ts-expect-error TS(2339): Property 'loading' does not exist on type 'Readonl... Remove this comment to see the full error message */}
            {!this.props.loading && (
              <span>
                {/* @ts-expect-error TS(2339): Property 'numberOfResults' does not exist on type ... Remove this comment to see the full error message */}
                <span data-testid={ifInTestingMode('filters__entity-count')}>{this.props.numberOfResults}</span>{' '}
                {/* @ts-expect-error TS(2339): Property 'numberOfResultsText' does not exist on t... Remove this comment to see the full error message */}
                {this.props.numberOfResultsText}
              </span>
            )}
          </div>
          <DropdownMenu
            renderedValue={{ translationId: 'components.Views.options' }}
            items={this.getViewDropdownOptions()}
            showSelected={false}
            className={`${CLASSES.NO_RIGHT_PADDING}`}
          />
        </Footer>
      </div>
    );
  }
}

const mapStateToProps = createStructuredSelector({
  loading: selectLoading(),
});

const mapDispatchToProps = (dispatch) =>
  bindActionCreators(
    {
      renameView,
      setDefaultView,
      deleteView,
    },
    dispatch
  );
// @ts-expect-error TS(2769): No overload matches this call.
export default connect(mapStateToProps, mapDispatchToProps)(injectIntl(Views));
